import * as Yup from "yup";

export const insurerSchema = Yup.object().shape({
  insurerName: Yup.string().required("Requerido"),
  description: Yup.string().required("Requerido"),
});
